export default __webpack_public_path__ + "static/media/3-responsive.12bc67b9.jpeg";